import React from 'react';
import { Gift } from 'lucide-react';
const PURCHASE_URL = 'https://digitalespro.com/cart/47867900788950:1';
export function BonusSection() {
  const bonuses = [{
    title: 'Bono #1 – Sistema de Evaluación Inteligente',
    subtitle: '30 páginas con:',
    list: ['Diagnóstico inicial', 'Evaluaciones por sistema', 'Evaluación final', 'Rúbrica de proyecto', 'Autoevaluación', 'Claves de corrección'],
    image: 'https://cdn.magicpatterns.com/uploads/aSCyHz4WsMQZBfDwCeS1b3/bono1_sin_fondo.png',
    color: 'bg-purple-600'
  }, {
    title: 'Bono #2 – MegaPack de Juegos Didácticos',
    subtitle: '40 páginas con:',
    list: ['Bingo', 'Trivia', '¿Quién soy?', 'Sopa de letras', 'Crucigramas', 'Estaciones rotativas'],
    image: 'https://cdn.magicpatterns.com/uploads/gXd34HjrCJ5QfopDrvLCzH/bono2_sin_fondo.png',
    color: 'bg-yellow-500'
  }, {
    title: 'Bono #3 – Planificador Estratégico de Ciencias',
    subtitle: '35 páginas con:',
    list: ['Plan anual', 'Plan mensual', 'Plan semanal', 'Seguimiento individual', 'Registro de evaluación'],
    image: 'https://cdn.magicpatterns.com/uploads/8nevuoysUqhsGMPRifE3WW/bono3_sin_fondo.png',
    color: 'bg-pink-500'
  }];
  return <section className="bg-gray-50 py-16 md:py-24 px-4" data-id="element-21">
      <div className="max-w-6xl mx-auto" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4 font-['Oswald'] uppercase" data-id="element-24">
            🎁 Regalos especiales
          </h2>
          <p className="text-2xl text-[#c0392b] font-bold uppercase tracking-wide mb-2" data-id="element-25">
            Bonos incluidos hoy
          </p>
          <p className="text-gray-600 font-medium" data-id="element-26">(Sin costo adicional)</p>
          <div className="mt-4 inline-block bg-yellow-300 text-yellow-900 font-bold px-4 py-1 rounded transform -rotate-2" data-id="element-27">
            ¡GRATIS solo por hoy!
          </div>
        </div>

        <div className="space-y-16" data-id="element-28">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200" data-id="element-29">
              <div className="grid md:grid-cols-2 gap-0" data-id="element-30">
                <div className="p-8 md:p-12 flex flex-col justify-center order-2 md:order-1" data-id="element-31">
                  <div className="inline-block bg-red-600 text-white text-xs font-bold px-3 py-1 rounded mb-4 w-fit" data-id="element-32">
                    GRATIS HOY
                  </div>
                  <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 font-['Oswald']" data-id="element-33">
                    🎁 {bonus.title}
                  </h3>
                  <p className="text-lg font-semibold text-gray-700 mb-4" data-id="element-34">
                    {bonus.subtitle}
                  </p>
                  <ul className="space-y-2 mb-6" data-id="element-35">
                    {bonus.list.map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-600" data-id="element-36">
                        <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-37"></div>
                        {item}
                      </li>)}
                  </ul>
                </div>
                <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="bg-gray-100 flex items-center justify-center p-8 order-1 md:order-2 cursor-pointer" data-id="element-38">
                  <img src={bonus.image} alt={bonus.title} className="w-full max-w-sm object-contain hover:scale-105 transition-transform duration-300 drop-shadow-xl" data-id="element-39" />
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}